import { createSlice } from '@reduxjs/toolkit';
import type { AsyncStatus } from '@/shared/types/asyncState';
import type { MetricasEntrega } from '../../types/metricasNotificacoes';
import { fetchNotificacoesMetricas } from './actions';

interface NotificacoesMetricasState {
  data: MetricasEntrega | null;
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
  currentRequestId: string | null;
}

const initialState: NotificacoesMetricasState = {
  data: null,
  loading: false,
  error: null,
  status: 'idle',
  currentRequestId: null,
};

const notificacoesMetricasSlice = createSlice({
  name: 'notificacoesMetricas',
  initialState,
  reducers: {
    clearNotificacoesMetricasError: (state) => {
      state.error = null;
      state.status = 'idle';
    },
    resetNotificacoesMetricas: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificacoesMetricas.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchNotificacoesMetricas.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.data = action.payload;
        state.status = 'success';
        state.currentRequestId = null;
      })
      .addCase(fetchNotificacoesMetricas.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
        state.currentRequestId = null;
      });
  },
});

export const { clearNotificacoesMetricasError, resetNotificacoesMetricas } =
  notificacoesMetricasSlice.actions;
export const notificacoesMetricasReducer = notificacoesMetricasSlice.reducer;
